module.exports = __webpack_public_path__ + "media/images/guide-thumb-4-5b81fe021a2a23ab847f1d930d2c8949.png";